import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import NRLink from '../../../../NRLink/NRLink';
import { VULNERABILITY_JIRA_TICKETS_LABELS } from '../vulnerabilityJiraTickets.constants';

function NRJiraTicketIdFormatter({ row }) {
  return (
    <Box minWidth={0}>
      <NRLink
        url={row.url}
        text={row.ticketKey}
        tooltipTitle={VULNERABILITY_JIRA_TICKETS_LABELS.OPEN_TICKET}
        sx={{ width: 'auto' }}
      />
      <Typography variant="body2" color="text.secondary" noWrap>
        {row.projectName}
      </Typography>
    </Box>
  );
}

export function NRJiraTicketIdProvider(props) {
  return <DataTypeProvider formatterComponent={NRJiraTicketIdFormatter} {...props} />;
}
